import React, { useState } from "react";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import { ReactComponent as TickIcon } from "assets/img/icons/tick.svg";
import { ReactComponent as Edit } from "assets/img/icons/Edit.svg";
import UserService from "services/UserService";
import CustomTextArea from "components/CustomTextArea";
import { useFormik } from "formik";
import { useToasts } from "react-toast-notifications";
import * as Yup from "yup";

const styles = {
  aboutMeSectionContainer: {
    marginLeft: "120px",
    display: "flex",
    justifyContent: "space-between",
    position: "relative",
  },
  aboutMeSection: {
    position: "relative",
    marginTop: "35px",
    flex: 1,
  },
  editAboutMe: {
    cursor: "pointer",
    position: "absolute",
    top: "6px",
    zIndex: "1000",
    right: "0",
    color: "white",
  },
  fullWidth: {
    width: "100%",
    minHeight: "50px",
    maxHeight: "150px",
  },
  iconsWidth: {
    width: "24px",
    height: "24px",
    fill: "black",
  },
  aboutMeText: {
    position: "absolute",
    top: "-26px",
    fontSize: "18px",
    fontWeight: 500,
    letterSpacing: "0.3px",
  },
  otherUserAboutMe: {
    minHeight: "50px",
    backgroundColor: "#e9ecef",
    opacity: 1,
    border: "1px solid #ced4da",
    paddingTop: "3px",
    paddingLeft: "4px",
    paddingRight: "4px",
    maxWidth: "870px",
    wordBreak: "break-word",
    whiteSpace: "break-spaces",
  },
};

export default ({ profile, setProfile, isOwner }) => {
  const classes = styles;
  const { addToast } = useToasts();
  const [editable, setEditable] = useState(false);

  const formik = useFormik({
    validateOnChange: false,
    validateOnBlur: false,
    initialValues: {
      about_me: profile?.profile?.about_me ?? "",
    },
    validationSchema: Yup.object().shape({
      about_me: Yup.string()
        .min(4, "Minimum 4 and maximum 500 characters are allowed")
        .max(500, "Minimum 4 and maximum 500 characters are allowed"),
    }),

    onSubmit: async (values) => {
      setEditable(false);
      if (!isOwner) {
        return;
      }
      try {
        await UserService.updateAboutMe(values.about_me);

        addToast("User about me updated successfully. ", {
          appearance: "success",
        });
      } catch (error) {}

      setProfile({
        ...profile,
        profile: {
          ...profile.profile,
          about_me: values.about_me,
        },
      });
    },
  });

  return (
    <div style={classes.aboutMeSectionContainer}>
      <div style={classes.aboutMeSection}>
        <span style={classes.aboutMeText}>About Me</span>
        {!isOwner && !!profile.profile.about_me && (
          <div style={classes.otherUserAboutMe}>{profile.profile.about_me}</div>
        )}
        {isOwner && (
          <CustomTextArea
            errorClass="errorMessage"
            textColor={"black"}
            textAreaClass="form-control profile-summary"
            formik={formik}
            label="About Me"
            placeholder="Write something about yourself."
            fieldName={"about_me"}
            limit={500}
            rows={3}
            disabled={!editable}
          />
        )}
      </div>
      {isOwner && (
        <span style={classes.editAboutMe}>
          {!editable && (
            <Edit
              style={classes.iconsWidth}
              onClick={() => setEditable(!editable)}
            />
          )}
          {editable && (
            <>
              <TickIcon
                className="tickIcon"
                style={classes.iconsWidth}
                onClick={formik.handleSubmit}
              />
              <CancelIcon
                className="aboutCancelIcon"
                style={classes.iconsWidth}
                onClick={() => {
                  formik.setErrors({});
                  formik.setFieldValue(
                    "about_me",
                    profile?.profile?.about_me ?? ""
                  );
                  setEditable(false);
                }}
              />
            </>
          )}
        </span>
      )}
    </div>
  );
};
